import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs'
)({
  component: BulkJobsLayout,
})

function BulkJobsLayout() {
  return <FeatureGate feature='image' />
}
